import axios from 'axios';

const hostname = process.env.REACT_APP_API_HOSTNAME || 'localhost';

export const getMagazines = async () => {
    const response = await axios.get(`${hostname}/magazine`);
    return response.data;
}

export const getMagazine = async (magazineId) => {
    const response = await axios.get(`${hostname}/magazine/${magazineId}`);
    return response.data;
}

export const getPublication = async (magazineId, publicationId) => {
    const response = await axios.get(`${hostname}/magazine/${magazineId}/publication/${publicationId}`);
    return response.data;
}

export const createMagazine = async (input) => {
    const response = await axios.post(`${hostname}/magazine`, input);
    return response.data;
}

export const createPublication = async (magazineId, input) => {
    const response = await axios.post(`${hostname}/magazine/${magazineId}/publication`, input);
    return response.data;
}

export const getPublicationPresignedUrl = async (magazineId, publicationId) => {
    const response = await axios.get(`${hostname}/magazine/${magazineId}/publication/${publicationId}/getPresignedUrl`);
    return response.data;
}

export const uploadPDF = async (url, pdf) => {
    const response = await axios.put(`${url}`, pdf);
    return response.data;
}

export const updatePublication = async (magazineId, publicationId, input) => {
    const response = await axios.put(`${hostname}/magazine/${magazineId}/publication/${publicationId}`, input);
    return response.data;
}

export const updateMagazine = async (magazineId, input) => {
    const response = await axios.put(`${hostname}/magazine/${magazineId}`, input);
    return response.data;
}
